import { Input, Textarea } from "@heroui/react";

const GeneralInfoStep = ({ register, errors }) => {
    return (
        <div className="flex flex-col gap-4">
            <Input
                {...register("name", {
                    required: "Nama gudang wajib diisi",
                })}
                label="Nama Gudang"
                placeholder="Contoh: Gudang Utama"
                variant="bordered"
                isInvalid={!!errors.name}
                errorMessage={errors.name?.message}
                isRequired
            />

            <Textarea
                {...register("description")}
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang gudang (opsional)"
                variant="bordered"
                minRows={3}
            />
        </div>
    );
};

export default GeneralInfoStep;
